export interface ProductoObjEspecifico{
    iddecinvproductoobjespecifico: number,
    iddecinvproyectoprodtermin: number,
    objetivo: string
}

export function getVoidProductoEspecifico():ProductoObjEspecifico{
    return{
        iddecinvproductoobjespecifico: 0,
        iddecinvproyectoprodtermin: 0,
        objetivo: ""
    }
}

export function setProductoEspecifico(row: any):ProductoObjEspecifico{
    return{
        iddecinvproductoobjespecifico: row.iddecinvproductoobjespecifico??0,
        iddecinvproyectoprodtermin: row.iddecinvproyectoprodtermin??0,
        objetivo: row.objetivo??""
    }
}

export function setListProductoEspecifico(data: Array<any>): Array<ProductoObjEspecifico>{
    let listEspc: Array<ProductoObjEspecifico> = [];
    data.forEach((item) => {
        const espc: ProductoObjEspecifico = setProductoEspecifico(item)
        listEspc.push(espc);
    });
    return listEspc;
}